import DAIButton from 'src/DAIComponents/Input/Button/DAIButton'

type DescriptionProps = {
  title: string
  description: string
  showButton?: boolean
  buttonText?: string
  onButtonClick?: () => void
}

const DescriptionModal = ({
  title,
  description,
  showButton = false,
  buttonText = '',
  onButtonClick,
}: DescriptionProps) => {
  return (
    <div className="space-y-4">
      <h2 className="text-xl font-semibold">{title}</h2>
      <p className="text-gray-700">{description}</p>
      <DAIButton
        text={buttonText}
        isVisible={showButton}
        onClick={onButtonClick}
      />
    </div>
  )
}

export default DescriptionModal
